import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const craftHighscoresApi = axios.create({
  baseURL: API_BASE_URL + "topcraft",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
